import * as React from 'react';
import { ProfileNavItemProps } from '../../Navigator.type';
import { NavigatorService } from '../../Navigator.service';
import { AvatarComponent } from '../../../horarios/components/avatar.component';

export function ProfileNavItem({
  user,
  account,
  activeItem,
  onOpenSubmenu
}: ProfileNavItemProps) {
  const isActive = activeItem === 'profile';
  const profileEditUrl = NavigatorService.getProfileEditUrl(account, user.id);
  const logoutUrl = NavigatorService.getLogoutUrl();

  return (
    <li className={`nav-item submenu ${isActive ? 'ativo' : ''}`}>
      <a
        onClick={(event) => onOpenSubmenu(event, 'profile')}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOpenSubmenu(e as any, 'profile'); } }}
        role="button"
        tabIndex={0}
      >
        <div className="avatar-wrapper">
          <AvatarComponent 
            aluno={user} 
            noLink={true} 
            hideName 
            size={30} 
            rounded
          />
        </div>
        <span>{user?.name}</span>
      </a>
      
      <ul className="submenu">
        <li>
          <a href={profileEditUrl}>
            <span>Meu Perfil</span>
          </a>
        </li>
        <li>
          <a 
            href={logoutUrl} 
            data-method="delete" 
            data-confirm="Você deseja sair?" 
            className="text-danger red-text"
          >
            <span>Sair</span>
          </a>
        </li>
      </ul>
    </li>
  );
}
